import React from 'react'
import NavigationCardSection from '../../../react4xp/components/NavigationCardSection'

interface NavigationCardSectionPartProps {
	title?: string
	intro?: string
	items: {
		image: string
		header: string
		text: string
		path: string
	}[]
}

function NavigationCardSectionPart({
	title,
	intro,
	items
}: NavigationCardSectionPartProps) {
	return (
		<div className='simple-card-grid-part'>
			{(title || intro) && (
				<div className='grid-container'>
					{title && (
						<h2 className='title-lg'>
							{title}
						</h2>
					)}

					{intro && (
						<div
							className='text-lg'
							dangerouslySetInnerHTML={{
								__html: intro
							}}
						/>
					)}
				</div>
			)}

			<div className='grid-container'>
				<NavigationCardSection items={items} />
			</div>
		</div>
	)
}

export default (props: NavigationCardSectionPartProps) => (
	<NavigationCardSectionPart {...props} />
)